<template>
<div class="leaps-action-list">
<div class="container-fluid" v-if="getLeapsActionList.length > 0">
  <div class="table-responsive margin-Top-6Perc" >
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right cursor-pointer">
            <span @click="selectedColumn('ActionVersion', 'asc', false)">Version</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionVersionSortOrder === 'desc'}" @click="selectedColumn('ActionVersion', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionVersionSortOrder === 'asc'}" @click="selectedColumn('ActionVersion', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right cursor-pointer">
            <span @click="selectedColumn('ActionName', 'asc', false)">Action Title</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionNameSortOrder === 'desc'}" @click="selectedColumn('ActionName', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionNameSortOrder === 'asc'}" @click="selectedColumn('ActionName', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right">
            <span @click="selectedColumn('IsActive', 'asc', false)">Is Active</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionIsActiveSortOrder === 'desc'}" @click="selectedColumn('IsActive', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currActionIsActiveSortOrder === 'asc'}" @click="selectedColumn('IsActive', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right">Attached Energies</th>
          <th class="text-align-center font-size-15px border-right">Attached Affirmations</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currLeapsActionObj in getLeapsActionList" :key="currLeapsActionObj.ActionLibraryId" :currLeapsActionObj="currLeapsActionObj">
          <td class="border-right text-align-center col-lg-1 col-md-1 border-right">{{(currLeapsActionObj.ActionVersion !== undefined && currLeapsActionObj.ActionVersion !== 'undefined' && currLeapsActionObj.ActionVersion !== null && currLeapsActionObj.ActionVersion !== 'null' && currLeapsActionObj.ActionVersion !== '' && currLeapsActionObj.ActionVersion.length !== 0) ? currLeapsActionObj.ActionVersion : ''}}</td>
          <td class="border-right text-align-center col-lg-4 col-md-4 border-right">{{currLeapsActionObj.ActionName}}</td>
          <td class="text-align-center col-lg-1 col-md-1 border-right">{{currLeapsActionObj.IsActive ? 'Yes' : 'No'}}</td> 
          <td class="text-align-center col-lg-2 col-md-2 border-right"><span v-html="getAttachedEngeries(currLeapsActionObj)"></span></td>
          <td class="text-align-center col-lg-2 col-md-2 border-right"><span v-html="getAttachedAffirmations(currLeapsActionObj)"></span></td>
          <td class="text-align-center col-lg-2 col-md-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currLeapsActionObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currLeapsActionObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currLeapsActionObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-leaps-action-overlay v-if="openEditOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></update-leaps-action-overlay>
  <view-leaps-action-overlay v-if="openViewOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></view-leaps-action-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteCurrentLeapsAction"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { leapsActionService } from '@/server-util/leaps-action-service'
import UpdateLeapsActionOverlay from '@/components/leaps/action/UpdateLeapsActionOverlay'
import ViewLeapsActionOverlay from '@/components/leaps/action/ViewLeapsActionOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import { forEach } from 'lodash'
import { constants } from '@/utils/constants'
import { leapsEnergyService } from '@/server-util/leaps-energy-service'
import { leapsAffirmationService } from '@/server-util/leaps-affirmation-service'
export default {
  props: ['leapsActionList'],
  created: function () {
    this.getLeapsEnergyList()
  },
  computed: {
    getLeapsActionList: {
      get: function () {
        return this.leapsActionList
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      currActionNameSortOrder: '',
      currActionVersionSortOrder: '',
      currActionIsActiveSortOrder: ''
    }
  },
  name: 'leaps-action-list',
  methods: {
    bindActionEnergies: function (actionEngeries) {
      var strToShow = ''
      var counter = 1
      forEach(actionEngeries, (energyId) => {
        const foundObj = find(this.$store.state.leapsEnergyList, (obj) => {
          return energyId === obj.EnergyId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          strToShow += counter + '. ' + foundObj.EnergyTitle + '<br/>'
          counter++
        }
      })
      return strToShow
    },
    getAttachedEngeries: function (currSelectedObj) {
      return (currSelectedObj.ActionEnergies !== undefined && currSelectedObj.ActionEnergies !== 'undefined' && currSelectedObj.ActionEnergies !== null && currSelectedObj.ActionEnergies !== 'null' && currSelectedObj.ActionEnergies !== '' && currSelectedObj.ActionEnergies.trim().length !== 0) ? this.bindActionEnergies(JSON.parse(currSelectedObj.ActionEnergies)) : 'Not Found'
    },
    bindActionAffirmations: function (actionAffirmations) {
      var strToShow = ''
      var counter = 1
      forEach(actionAffirmations, (affirmationLibraryId) => {
        const foundObj = find(this.$store.state.leapsAffirmationList, (obj) => {
          return affirmationLibraryId === obj.AffirmationLibraryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          strToShow += counter + '. ' + foundObj.AffirmationTitle + '<br/>'
          counter++
        }
      })
      return strToShow
    },
    getAttachedAffirmations: function (currSelectedObj) {
      return (currSelectedObj.ActionAffirmations !== undefined && currSelectedObj.ActionAffirmations !== 'undefined' && currSelectedObj.ActionAffirmations !== null && currSelectedObj.ActionAffirmations !== 'null' && currSelectedObj.ActionAffirmations !== '' && currSelectedObj.ActionAffirmations.trim().length !== 0) ? this.bindActionAffirmations(JSON.parse(currSelectedObj.ActionAffirmations)) : 'Not Found'
    },
    getLeapsEnergyList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsEnergyList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsEnergyService
          .getLeapsEnergyList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsEnergyList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
              this.getLeapsAffirmationList()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ENGERY LIST'
        )
      }
    },
    getLeapsAffirmationList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsAffirmationList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsAffirmationService
          .getLeapsAffirmationList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsAffirmationList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS AFFIRMATION LIST'
        )
      }
    },
    selectedColumn: function (currSelectedColumn, orderBy = 'asc', clickedOnArrow) {
      var emitVal = false
      switch (currSelectedColumn) {
        case 'IsActive':
          if (clickedOnArrow) {
            if (this.currActionIsActiveSortOrder === orderBy) {
              currSelectedColumn = 'IsActive'
              emitVal = false
            } else {
              this.currActionIsActiveSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currActionIsActiveSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currActionIsActiveSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'IsActive'
            this.currActionIsActiveSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            var objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currActionVersionSortOrder = ''
          this.currActionNameSortOrder = ''
          break
        case 'ActionName':
          if (clickedOnArrow) {
            if (this.currActionNameSortOrder === orderBy) {
              currSelectedColumn = 'ActionName'
              emitVal = false
            } else {
              this.currActionNameSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currActionNameSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currActionNameSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'ActionName'
            this.currActionNameSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currActionVersionSortOrder = ''
          this.currActionIsActiveSortOrder = ''
          break
        case 'ActionVersion':
          if (clickedOnArrow) {
            if (this.currActionVersionSortOrder === orderBy) {
              currSelectedColumn = 'ActionVersion'
              emitVal = false
            } else {
              this.currActionVersionSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currActionVersionSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currActionVersionSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'ActionVersion'
            this.currActionVersionSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currActionNameSortOrder = ''
          this.currActionIsActiveSortOrder = ''
          break
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
      var objToEmit = {
        updateValues: false,
        SortType: '',
        ColumnName: ''
      }
      this.$emit('sortBasedOnColumnName', objToEmit)
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.currSelectedObj.ActionName + '\' action?'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteCurrentLeapsAction (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.ActionLibraryId !== undefined &&
          this.currSelectedObj.ActionLibraryId !== null
        ) {
          this.$store.state.isLoading = true
          leapsActionService
            .deleteLeapsAction(
              storeObj.state.access_token,
              this.currSelectedObj.ActionLibraryId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterLeapActionList()
                  this.$store.state.isLoading = false
                  var objToEmit = {
                    updateValues: false,
                    SortType: '',
                    ColumnName: ''
                  }
                  this.$emit('sortBasedOnColumnName', objToEmit)
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'ActionLibraryId is NULL hence declined DELETE LEAP ACTION Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterLeapActionList: function () {
      const foundIndex = findIndex(this.$store.state.leapsActionList, (obj) => {
        return obj.ActionLibraryId === this.currSelectedObj.ActionLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsActionList.splice(foundIndex, 1)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-leaps-action-overlay': UpdateLeapsActionOverlay,
    'view-leaps-action-overlay': ViewLeapsActionOverlay,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.margin-left-0px {
  margin-left: 0px !important;
}
.margin-right-0px {
  margin-right: 0px !important;
}
.font-size-13px {
  font-size: 13px;
}
.float-right {
  float: right;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0Point2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.leaps-action-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/action/LeapsActionList.vue